import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-24 pb-12 md:pt-32 md:pb-16 px-4 bg-white" data-id="element-79">
      <div className="max-w-4xl mx-auto text-center" data-id="element-80">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-6 tracking-tight" data-id="element-81">
          ¿Cuántas veces hoy ya perdiste la paciencia con tus hijos?
        </h1>

        {/* Real Product Image */}
        <div className="relative w-full max-w-2xl mx-auto my-12 cursor-pointer" onClick={scrollToPricing} data-id="element-82">
          <div className="absolute inset-0 bg-yellow-300 blur-3xl opacity-20 rounded-full -z-10" data-id="element-83" />
          <img src="https://cdn.magicpatterns.com/uploads/bsHsKwT54KqnULakoAuxPz/mocap_metodo_calma.png" alt="MÉTODO CALMA® - Megapack Premium - Colección Completa - 6 Tomos + 4 Bonos" className="w-full h-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-id="element-84" />
        </div>

        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-red-600 mb-8 max-w-3xl mx-auto" data-id="element-85">
          Si gritar se convirtió en tu forma de pedir silencio... esto es para
          vos.
        </h2>

        <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 md:p-8 mb-10 shadow-sm" data-id="element-86">
          <p className="text-lg md:text-xl text-gray-800 font-medium leading-relaxed" data-id="element-87">
            <strong data-id="element-88">Descubrí el sistema paso a paso</strong> que miles de mamás
            ya usan para criar con calma, poner límites sin gritos y volver a
            disfrutar a sus hijos —{' '}
            <span className="underline decoration-yellow-400 decoration-4 underline-offset-2" data-id="element-89">
              sin culpa y sin agotamiento.
            </span>
          </p>
        </div>

        <CTAButton text="👉 QUIERO EL MÉTODO CALMA® AHORA" onClick={scrollToPricing} subtext="Descarga inmediata • Garantía de satisfacción de 7 días" data-id="element-90" />
      </div>
    </section>;
}